import { Component, inject, OnInit } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { NavbarService } from '../../../Services/navbar.service';
import { FirmService } from '../../../Services/firm.service';
import { FirmSelectionService } from '../../../Services/firm-selection.service';
import { NotificationService } from '../../../Services/notification.service';
import { CustomizeService } from '../../../Services/Customize_settings/customize.service';
import { AuthService } from '../../../Services/auth.service';

@Component({
  selector: 'app-home-navbar',
  standalone: true,
  imports: [NgIf, NgClass, NgFor, RouterLink, FormsModule],
  templateUrl: './home-navbar.component.html',
  styleUrl: './home-navbar.component.css',
})
export class HomeNavbarComponent implements OnInit {

  firmnames: string[] = [];
  selectedFirm: string | null | undefined;
  navbarOptions: any[] = [];
  logoImage: any;
  isFirmLocked: boolean = false;

  constructor(private firmService: FirmService, private firmSelectionService: FirmSelectionService, private navService: NavbarService, private notificationService: NotificationService, private customizeService: CustomizeService, private authService: AuthService) { }

  router = inject(Router);

  menuOpen = false;

  // mobile submenu expand/collapse state
  mobileExpanded: string | null = null;

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  toggleSubmenu(path: string) {
    this.mobileExpanded = this.mobileExpanded === path ? null : path;
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
    this.menuOpen = false;       // close mobile menu
    this.mobileExpanded = null;  // collapse submenu
  }

  ngOnInit(): void {
    // 🔥 Listen for logo changes
    this.customizeService.logo$.subscribe((logo) => {
      if (logo) {
        this.logoImage = logo;
      }
    });

    const userRole = sessionStorage.getItem('role');
    this.isFirmLocked = (sessionStorage.getItem('is_firm_restricted') === 'true') || (userRole === 'Staff');

    this.firmService.getFirms().subscribe((response: any) => {
      const firms = response.data;
      this.firmnames = firms.map((firm: any) => firm.name);

      // Reflect current selection
      this.firmSelectionService.selectedFirmName$.subscribe(firm => {
        if (firm) {
          this.selectedFirm = firm.name;
        }
      });

    });

    this.loadFirms();  // initial load

    // 👇 NEW: Listen for updates from FirmService
    this.firmService.firmsUpdated$.subscribe(() => {
      this.loadFirms(); // reload whenever a firm is added/edited/deleted
    });

    this.navService.navbarOptions$.subscribe(options => {
      this.navbarOptions = options;
    });

    this.navService.navbarOptions$.subscribe(options => {
      this.navbarOptions = options;
    });
  }


  onFirmChange(name: string) {
    this.firmService.getFirms().subscribe((response: any) => {
      const firm = response.data.find((f: any) => f.name === name);
      if (firm) {
        this.switchFirm(firm);
      }
    });
  }

  switchFirm(firm: any) {
    this.selectedFirm = firm.name;
    this.firmSelectionService.setselectedFirmName({ id: firm.id, name: firm.name, status: firm.gst_status });
    localStorage.setItem('firm_id', firm.id.toString());
    this.notificationService.showSuccess(`Switched to ${firm.name}`, 'Success');

    // Redirection based on GST status
    const s = firm.gst_status?.toString().toLowerCase();
    const n = firm.name?.toLowerCase();
    const isGstFirm = (['gst', 'yes', '1', 'true', 'registered'].includes(s)) ||
      (n?.includes('gst') && !n?.includes('non-gst') && !n?.includes('non gst'));

    // Get user role from session
    const userRole = sessionStorage.getItem('role');

    if (userRole === 'Owner') {
      if (isGstFirm) {
        this.router.navigate(['/invoice-gst-panel']);
      } else {
        this.router.navigate(['/home']);
      }
    }
    // For staff, we could also add logic here if they switch (if allowed)

    // location.reload(); 
  }

  private loadFirms() {
    this.firmService.getFirms().subscribe((response: any) => {
      const firms = response.data;
      this.firmnames = firms.map((firm: any) => firm.name);

      // Reflect current selection
      this.firmSelectionService.selectedFirmName$.subscribe(firm => {
        if (firm) {
          this.selectedFirm = firm.name;
        }
      });
    });
  }
  isUserMenuOpen = false;

  toggleUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  onFocusOut(event: FocusEvent): void {
    const currentTarget = event.currentTarget as HTMLElement | null;
    const relatedTarget = event.relatedTarget as HTMLElement | null;

    if (!currentTarget) {
      this.isUserMenuOpen = false;
      return;
    }

    // ✅ Close only if focus moved outside the wrapper
    if (!relatedTarget || !currentTarget.contains(relatedTarget)) {
      this.isUserMenuOpen = false;
    }
  }

  logout(): void {
    this.isUserMenuOpen = false;
    this.notificationService.showSuccess(
      'Logged out successfully.',
      'Logout'
    );
    this.authService.logout();
  }
}
